import request from '@/utils/request';

/**
 * 保存装修页
 */
export function saveOrUpdateApi(data) {
  return request({
    url: '/admin/company-design/saveOrUpdate',
    method: 'POST',
    data: data
  });
}

/**
 *装修模拟首页商品
 */
export function homeApi(params) {
  return request({
    url: '/admin/store/product/index/home',
    method: 'GET',
    params: params
  });
}

/**
 *装修模拟首页商品-拼团
 */
export function homePinApi(params) {
  return request({
    url: '/admin/store/combination/index',
    method: 'GET',
    params: params
  });
}

/**
 * 详情
 */
export function getDetailApi(params) {
  return request({
    url: '/admin/company-design/getDetail',
    method: 'GET',
    params: params
  });
}